// extracted by mini-css-extract-plugin
export default {"navigationBody":"navigation_navigationBody__MOLwR","option":"navigation_option__0ZZzy","active":"navigation_active__uPm-F"};